'use client'

import Title from '@/app/components/common/Title'
import TranslateString from '@/app/components/common/TranslateString'
import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { FC } from 'react'

interface Props {
	className?: string
	sanityHeading?: string
}
const SiteSubheading: FC<Props> = ({ className, sanityHeading }) => {
	return (
		<Title
			level="3"
			size="sm"
			bold
			className={classNames(
				`block text-center xl:text-base lg:tracking-[1.4px]  xl:tracking-[1.6px] relative z-10 px-2 uppercase ${className}`
			)}
		>
			{sanityHeading ? (
				sanityHeading
			) : (
				<TranslateString
					i18nKey={'newDesign.partnersHeading'}
					context={'Main'}
				/>
			)}
		</Title>
	)
}

export default dynamic(() => Promise.resolve(SiteSubheading), { ssr: false })
